import React from 'react';
import './XiAtmosphere.css';

/**
 * XiAtmosphere — local, asset-free cinematic backdrop.
 *
 * Deliberately generates its composition with layered CSS radial/linear
 * gradients only: no external URLs, no downloaded imagery, no generated
 * images, no text baked in. It is the sanctioned temporary fallback until
 * the final cinematic Xi images are added under /assets/xi/.
 *
 * Dark and light compositions are art-directed separately via
 * body[data-theme] so neither theme inherits the other's lighting.
 *
 * @param {object} props
 * @param {'auth'|'hero'|'panel'} [props.variant='hero'] Composition scale/tightness.
 * @param {boolean} [props.dots=true] Show the faint Xi three-dot constellation.
 * @param {string}  [props.className=''] Extra layout classes.
 */
export default function XiAtmosphere({
  variant = 'hero',
  dots = true,
  className = '',
}) {
  return (
    <div
      className={`xi-atmosphere xi-atmosphere--${variant} ${className}`.trim()}
      aria-hidden="true"
    >
      <span className="xi-atmosphere__layer xi-atmosphere__layer--violet" />
      <span className="xi-atmosphere__layer xi-atmosphere__layer--blue" />
      <span className="xi-atmosphere__layer xi-atmosphere__layer--cyan" />
      <span className="xi-atmosphere__layer xi-atmosphere__layer--horizon" />
      <span className="xi-atmosphere__grain" />

      {dots && (
        <span className="xi-atmosphere__constellation">
          <i className="xi-atmosphere__spark xi-atmosphere__spark--violet" />
          <i className="xi-atmosphere__spark xi-atmosphere__spark--blue" />
          <i className="xi-atmosphere__spark xi-atmosphere__spark--cyan" />
        </span>
      )}
    </div>
  );
}
